import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Pastrimi i thellë ndryshoi plotësisht lëkurën time. Pas vetëm dy seancave, poret ishin minimizuar dhe lëkura kishte një shkëlqim të pabesueshëm. Kurrë nuk kam ndier kaq mirë.",
    name: "Sofia M.",
    treatment: "Deep Cleansing",
  },
  {
    quote:
      "HydraFacial-i ishte gjëja më e mirë që bëra për veten time. Rezultati ishte i menjëhershëm — lëkura ishte si e rinovuar. Elaia e di saktësisht çfarë bën.",
    name: "Amelia R.",
    treatment: "HydraFacial",
  },
  {
    quote:
      "Trajtimi Ultra Contour Touch Vecom dha rezultate që nuk i prisja kaq shpejt. Silueta ime u formësua dukshëm dhe lëkura u tonifikua. Jam tepër e kënaqur.",
    name: "Isabelle D.",
    treatment: "Ultra Contour Touch",
  },
  {
    quote:
      "Nga momenti që hyra, u ndjeva e kujdesur dhe e vlerësuar. Konsulta ishte e hollësishme dhe trajtimi Dermapen u përshtat perfektisht me lëkurën time të ndjeshme.",
    name: "Natalie P.",
    treatment: "Dermapen (Microneedling)",
  },
  {
    quote:
      "Profesionale, e ditur dhe me pasion të vërtetë për punën e saj. Lëkura ime nuk ka qenë kurrë më e bukur. E rekomandoj Elaia-n te të gjithë njerëzit që njoh.",
    name: "Laura K.",
    treatment: "Peeling Kimik",
  },
  {
    quote:
      "Maderoterapia ishte e mrekullueshme — qarkullimi u përmirësua menjëherë dhe celuliti u zvogëlua dukshëm pas disa seancave. Ky vend është parajsa e lëkurës sime.",
    name: "Marta T.",
    treatment: "Maderoterapia",
  },
];

const Testimonials = () => {
  return (
    <Section>
      <Inner>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <Label>Çfarë Thonë Klientët</Label>
          <Title>
            Stories of
            <br />
            <em>Transformation</em>
          </Title>
        </motion.div>

        <Grid>
          {testimonials.map((t, i) => (
            <TestiCard
              key={i}
              as={motion.div}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -6, transition: { duration: 0.3 } }}
            >
              <Stars>{"★".repeat(5)}</Stars>
              <Quote>"{t.quote}"</Quote>
              <ClientRow>
                <Avatar>{t.name.charAt(0)}</Avatar>
                <div>
                  <ClientName>{t.name}</ClientName>
                  <ClientTreatment>{t.treatment}</ClientTreatment>
                </div>
              </ClientRow>
            </TestiCard>
          ))}
        </Grid>
      </Inner>
    </Section>
  );
};

const Section = styled.section`
  background: var(--charcoal);
  padding: 140px 0;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 60px;
    right: 60px;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(196, 149, 122, 0.2),
      transparent
    );
  }
`;
const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 60px;
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;
const Label = styled.span`
  display: block;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 20px;
`;
const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(44px, 5.5vw, 80px);
  font-weight: 300;
  color: var(--cream);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 72px;
  em {
    font-style: italic;
    color: var(--rose);
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
const TestiCard = styled.div`
  background: rgba(209, 197, 188, 0.5);
  border: 1px solid rgba(196, 149, 122, 0.08);
  padding: 44px 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  transition:
    border-color 0.3s,
    background 0.3s;
  &:hover {
    border-color: rgba(196, 149, 122, 0.2);
    background: rgb(199, 181, 170);
  }
`;
const Stars = styled.div`
  color: var(--gold);
  font-size: 14px;
  letter-spacing: 2px;
`;
const Quote = styled.p`
  font-family: var(--font-display);
  font-size: clamp(16px, 1.6vw, 19px);
  font-style: italic;
  font-weight: 300;
  color: var(--cream);
  line-height: 1.7;
  margin: 0;
  flex: 1;
`;
const ClientRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border-top: 1px solid rgba(196, 149, 122, 0.1);
  padding-top: 20px;
`;
const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--rose);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-size: 18px;
  color: var(--charcoal);
  flex-shrink: 0;
`;
const ClientName = styled.div`
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 400;
  color: var(--cream);
  letter-spacing: 0.05em;
`;
const ClientTreatment = styled.div`
  font-family: var(--font-body);
  font-size: 11px;
  color: var(--rose);
  letter-spacing: 0.1em;
  margin-top: 3px;
`;

export default Testimonials;
